import { defaultProps } from "prism-react-renderer";
import nightOwl from "prism-react-renderer/themes/nightOwl";

export const defaultHighlightProps = {
  ...defaultProps,
  theme: nightOwl,
};
